import React from 'react';
import { IconProps } from './types';

export const DiceIcon: React.FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="8" cy="8" r="1.5" />
    <circle cx="16" cy="16" r="1.5" />
    <circle cx="8" cy="16" r="1.5" />
    <circle cx="16" cy="8" r="1.5" />
    <circle cx="12" cy="12" r="1.5" />
  </svg>
);
